export default "__VITE_ASSET__L1g$x6c3__"